import { decryptV3App, decryptV3H5, isInApp, } from '@docs/common';
import { AxiosResponse } from 'axios';
import { omit } from 'lodash';
import { checkResponseSignature } from './encryption';
import { buildCredentialHeaders, getEdchKeySession } from './header';

// start_ai_generated
export const handleV3Response = async (response: AxiosResponse<any>,domain?:string) => {
  let _data = response.data || {};
  // 如果是在app 调用app的解密方法
  if (await isInApp()) {
    if (typeof _data === 'string') {
      _data = await decryptV3App({ type: 0, data: _data, domain:domain || '' });
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3App({ type: 0, data: _data.data,domain:domain || '' })
      };
    }
  } else {
    // 如果是在h5 调用h5的解密方法
    const ecdhKey = await getEdchKeySession();
    const { randomField } = buildCredentialHeaders();
    if (!ecdhKey || !checkResponseSignature(ecdhKey.shareKey, randomField, _data)) {
      return Promise.reject({ ...response, message: 'signature mismatch' });
    }
    if (typeof _data === 'string') {
      _data = await decryptV3H5(_data, ecdhKey.shareKey);
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3H5(_data.data, ecdhKey.shareKey)
      };
    }
  }
  return _data;
};
// end_ai_generated